import React from "react";
import cssClass from "./press-kit.module.css";

const PressKit = () => (
  <div className={cssClass.pressKit}>
    <a href="/AwC-PressKit.zip">Go to Press Kit</a>
  </div>
);

export default PressKit;